import axiosInstance from "./axiosInstance";
import { Dispatch, SetStateAction } from "react";
import { statusItems } from "@/constants/status";

export const updateStatusByTotal = async (
  startDate: Date,
  endDate: Date,
  setStatusMenu: Function,
  setTotalOrders: Function,
  statusItemsCustom: { label: string; status: string }[] = statusItems,
  filterByCreatedDate: boolean = false,
) => {
  const uri = filterByCreatedDate
    ? `taxi-orders/total-by-status?createdDateFrom=${startDate.toISOString()}&createdDateTo=${endDate.toISOString()}`
    : `taxi-orders/total-by-status?pickupTime=${startDate.toISOString()}&endPickupTime=${endDate.toISOString()}`;

  const { data } = await axiosInstance.get(uri);
  if (data) {
    const statusMenuTemp: any = [];
    let totalOrdersTemp = 0;

    for (let index = 0; index < statusItemsCustom.length; index++) {
      const element: any = { ...statusItemsCustom[index] };
      let found = false;

      Object.keys(data).forEach((key) => {
        if (element.status === data[key].status) {
          element.total = data[key].total;
          totalOrdersTemp += data[key].total;
          found = true;
        }
      });

      if (!found) {
        element.total = 0;
      }

      statusMenuTemp.push(element);
    }

    setStatusMenu(statusMenuTemp);
    setTotalOrders(totalOrdersTemp);
  }
};

export const fetchClientFromPhone = (
  clientNameCache: any,
  setClientName: Dispatch<SetStateAction<string>>,
  phoneNumber: string,
) => {
  const rootPhone = phoneNumber ? phoneNumber.slice(-9) : "";

  if (!rootPhone) return;

  if (clientNameCache.has(rootPhone)) {
    setClientName(clientNameCache.get(rootPhone) as string);
    return;
  }

  const fetchClientName = async () => {
    try {
      const { data } = await axiosInstance.get(
        `/taxi-clients/phone/${rootPhone}`,
      );
      if (data.name) {
        setClientName(data.name);
        clientNameCache.set(rootPhone, data.name);
      } else setClientName("");
    } catch (err) {
      console.log(err);
    }
  };

  fetchClientName();
};

export const calculateTransferPrice = (km: number, vehicleClass: string) => {
  let pricePerKm = 0;

  if (vehicleClass === "economy") {
    if (km <= 10) pricePerKm = 2;
    else if (km > 10 && km <= 20) pricePerKm = 1;
    else if (km > 20 && km <= 100) pricePerKm = 0.9;
    else if (km < 100 && km <= 200) pricePerKm = 0.85;
    else pricePerKm = 0.75;
  } else {
    if (km <= 10) pricePerKm = 3;
    else if (km > 10 && km <= 20) pricePerKm = 1.5;
    else if (km > 20 && km <= 100) pricePerKm = 1.35;
    else if (km < 100 && km <= 200) pricePerKm = 1.27;
    else pricePerKm = 1.12;
  }

  const totalPrice = Math.floor(km * pricePerKm * 100) / 100;

  return totalPrice > 5 ? totalPrice : 5;
};

export const getNestedProperty = (obj: any, prop: string) => {
  return prop.split(".").reduce((acc, k) => acc?.[k], obj);
};

export const formatAddress = (
  addressComponents: google.maps.GeocoderAddressComponent[],
) => {
  // Filter out unwanted components but keep useful ones
  const parts: string[] = [];
  const skipTypes = [
    "plus_code",
    "country",
    "postal_code",
    "administrative_area_level_1", // State/County (e.g., "Tirana County")
  ];

  for (const component of addressComponents) {
    // Skip if any of the component types should be filtered out
    const shouldSkip = component.types.some((type) => skipTypes.includes(type));
    if (!shouldSkip && component.long_name) {
      // Avoid duplicates
      if (!parts.includes(component.long_name)) {
        parts.push(component.long_name);
      }
    }
  }

  const result = parts.join(", ");
  return result;
};

export const handleRowClick = (
  row: any, setRow: Dispatch<SetStateAction<any>>, setOpen: Dispatch<SetStateAction<boolean>>
) => {
  setOpen(true)
  setRow(row)
}
